import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotPhoneComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotPhone',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F5990D",
    fillRule: "evenodd",
    d: "M16 2H8C6.35 2 5 3.35 5 5v14c0 1.65 1.35 3 3 3h8c1.65 0 3-1.35 3-3V5c0-1.65-1.35-3-3-3Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FCC406",
    fillRule: "evenodd",
    d: "M17 19c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h1.22l.79 1h4l.78-1H16c.55 0 1 .45 1 1v14Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F5990D",
    d: "M12 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  }));
};
SpotPhoneComponent.displayName = 'SpotPhone';
export var SpotPhone = withProvisionalOverrideFromContext(SpotPhoneComponent);
//# sourceMappingURL=index.js.map